import { useCallback } from 'react';

import { Spinner } from '@change/ds-core-ui';

import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { MediaStep } from './Media';

async function LoadMediaStep(): Promise<typeof MediaStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-media" */ './Media')).MediaStep;
}

export const MediaLoader: React.FC = () => {
	const loadComponent = useCallback(async () => LoadMediaStep(), []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Spinner />
				</Box>
			}
		/>
	);
};

export const preloadMediaStep = LoadMediaStep;
